import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/apiClient.ts'

type useDownloadFile = {
  downloadName?: string
  fileId: string
  contentDisposition?: 'inline' | 'attachment'
}

export const generateOptions = (args: useDownloadFile) =>
  queryOptions({
    queryKey: ['file-download', args],
    queryFn: () =>
      apiClient.files[':fileId'].download
        .$get({
          param: { fileId: args.fileId },
          query: {
            downloadName: args.downloadName,
            contentDisposition: args.contentDisposition,
          },
        })
        .then(async (r) => await r.json()),
  })

export const useDownloadFile = (
  args: useDownloadFile,
  options?: Partial<ReturnType<typeof generateOptions>>
) =>
  useQuery({
    ...generateOptions(args),
    ...options,
  })

useDownloadFile.queryOptions = generateOptions

export async function downloadFile(args: useDownloadFile) {
  const result = await apiClient.files[':fileId'].download
    .$get({
      param: { fileId: args.fileId },
      query: {
        downloadName: args.downloadName,
        contentDisposition: args.contentDisposition,
      },
    })
    .then(async (r) => await r.json())

  if (result.success) {
    forceDownload({ url: result.data.downloadUrl, name: args.downloadName })
  }
}

function forceDownload(options: { url: string; name?: string }) {
  const { url, name } = options
  const link = document.createElement('a')
  link.href = url
  if (name) {
    link.download = name
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
